import { onGetCategories, onGetDealsCategoriesList } from '../../util/api';
import { types as sdkTypes } from '../../util/sdkLoader';
// import { parse } from '../../util/urlHelpers';
// import { error } from '../../util/log';

const { UUID } = sdkTypes;
// const RESULT_PAGE_SIZE = 24;

// ================ Action types ================ //

export const SEARCH_LISTINGS_REQUEST = 'app/AlgoliaSearchPage/SEARCH_LISTINGS_REQUEST';
export const SEARCH_LISTINGS_SUCCESS = 'app/AlgoliaSearchPage/SEARCH_LISTINGS_SUCCESS';
export const SEARCH_LISTINGS_ERROR = 'app/AlgoliaSearchPage/SEARCH_LISTINGS_ERROR';
export const ALGOLIA_SEARCH_RESULTS = 'app/AlgoliaSearchPage/ALGOLIA_SEARCH_RESULTS';

export const DEALS_CATEGORIES_REQUEST = 'app/AlgoliaSearchPage/DEALS_CATEGORIES_REQUEST';
export const DEALS_CATEGORIES_SUCCESS = 'app/AlgoliaSearchPage/DEALS_CATEGORIES_SUCCESS';
export const DEALS_CATEGORIES_ERROR = 'app/AlgoliaSearchPage/DEALS_CATEGORIES_ERROR';

export const CATEGORIES_REQUEST = 'app/AlgoliaSearchPage/CATEGORIES_REQUEST';
export const CATEGORIES_SUCCESS = 'app/AlgoliaSearchPage/CATEGORIES_SUCCESS';
export const CATEGORIES_ERROR = 'app/AlgoliaSearchPage/CATEGORIES_ERROR';

// ================ Reducer ================ //

const initialState = {
  searchParams: null,
  pagination: null,
  searchInProgress: false,
  searchListings: [],
  searchListingsError: null,
  algoliaSearchResults: [],
  dealsCategoriesRequest: false,
  dealsCategories: [],
  dealsCategoriesError: null,
  categoriesRequest: false,
  categories: [],
  categoriesError: null,
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case ALGOLIA_SEARCH_RESULTS:
      return {
        ...state,
        algoliaSearchResults: payload,
      };
    case SEARCH_LISTINGS_REQUEST:
      return {
        ...state,
        searchParams: payload,
        searchInProgress: true,
        pagination: null,
        searchListings: [],
        searchListingsError: null,
      };
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        searchListingsError: null,
      };
    case SEARCH_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return {
        ...state,
        searchInProgress: false,
        searchListingsError: payload,
        searchListings: [],
        pagination: null,
      };

    case DEALS_CATEGORIES_REQUEST:
      return {
        ...state,
        dealsCategoriesRequest: true,
        dealsCategoriesSuccess: [],
      };

    case DEALS_CATEGORIES_SUCCESS:
      return {
        ...state,
        dealsCategoriesRequest: false,
        dealsCategoriesSuccess: payload,
      };

    case DEALS_CATEGORIES_ERROR:
      return {
        ...state,
        dealsCategoriesError: payload,
      };

    case CATEGORIES_REQUEST:
      return {
        ...state,
        categoriesRequest: true,
        categories: [],
      };

    case CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesRequest: false,
        categories: payload,
      };

    case CATEGORIES_ERROR:
      return {
        ...state,
        categoriesError: payload,
      };

    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const categoriesRequest = () => ({
  type: DEALS_CATEGORIES_REQUEST,
});

export const categoriesSuccess = payload => ({
  type: DEALS_CATEGORIES_SUCCESS,
  payload: payload,
});

export const categoriesError = response => ({
  type: DEALS_CATEGORIES_ERROR,
  payload: response,
});

export const categoriesRequestFn = () => ({
  type: CATEGORIES_REQUEST,
});

export const categoriesSuccessFn = payload => ({
  type: CATEGORIES_SUCCESS,
  payload: payload,
});

export const categoriesErrorFn = response => ({
  type: CATEGORIES_ERROR,
  payload: response,
});

export const algoliasearchResults = data => ({
  type: ALGOLIA_SEARCH_RESULTS,
  payload: data,
});
export const searchListingsRequest = searchParams => ({
  type: SEARCH_LISTINGS_REQUEST,
  payload: searchParams,
});

export const searchListingsSuccess = response => ({
  type: SEARCH_LISTINGS_SUCCESS,
  payload: response,
});

export const searchListingsError = e => ({
  type: SEARCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const searchListings = searchParams => async (dispatch, getState, sdk) => {
  try {
    //fetching result in-progress
    dispatch(searchListingsRequest());
  } catch (error) {
    console.error('error..', error);
    dispatch(searchListingsSuccess());
  }
};

export const getAlgoliasearchResults = params => (dispatch, getState, sdk) => {
  try {
    dispatch(algoliasearchResults(params));
  } catch (error) { }
};

export const categoriesListing = () => async dispatch => {
  dispatch(categoriesRequest);
  try {
    const response = await onGetDealsCategoriesList();
    dispatch(categoriesSuccess(response));
    return response;
  } catch (error) {
    dispatch(categoriesError(error.message));
  }
};

export const serviceCategoriesListing = () => async dispatch => {
  dispatch(categoriesRequestFn);
  try {
    const response = await onGetCategories();
    dispatch(categoriesSuccessFn(response));
    return response;
  } catch (error) {
    dispatch(categoriesErrorFn(error.message));
  }
};

export const fetchAuthorData = ({ userId }) => async (dispatch, getState, sdk) => {
  try {
    const result = await sdk.users.show({ id: new UUID(userId) });
    return result?.data?.data;
  } catch (error) { }
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  return Promise.all([dispatch(categoriesListing()), dispatch(searchListings())]);
};
